import {
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Limited Release By Region
function getTargetGroupsByPhysical(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/physical/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createTargetGroupsByPhysical(requestBody) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };

  const endPoint = `/api/admin/v1/groups/physical`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editTargetGroupsByPhysical(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/physical/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteTargetGroupsByPhysical(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/physical/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const targetGroupsPhysicalService = {
  getTargetGroupsByPhysical,
  createTargetGroupsByPhysical,
  editTargetGroupsByPhysical,
  deleteTargetGroupsByPhysical,
};
